if (typeof window.addIconCart === 'undefined') {
  window.addIconCart = function(e, variantId, btn) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    var origHTML = btn.innerHTML;
    var productCard = btn.closest('.grid-product__content');
    var productRoot = btn.closest('[data-product-id]');
    var productTitleNode = productCard ? productCard.querySelector('.grid-product__title') : null;

    function openCartDrawer() {
      window.setTimeout(function() {
        var cartLink = document.querySelector('.js-drawer-open-cart');
        if (cartLink && cartLink.getAttribute('aria-expanded') !== 'true') cartLink.click();
      }, 450);
    }

    function performIconAdd() {
      btn.innerHTML = '<span style="font-size: 14px; font-weight: bold;">...</span>';
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      var rootUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Cart request failed');
          return data;
        });
      })
      .then(function(data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));

        if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
          theme.cart.getCart();
        } else if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
          ajaxCart.load();
        }

        openCartDrawer();
        btn.innerHTML = '<span style="font-size: 14px; font-weight: bold;">✓</span>';
        btn.removeAttribute('aria-busy');
        window.setTimeout(function() {
          btn.innerHTML = origHTML;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function(error) {
        console.warn('Astroida quick add:', error);
        btn.innerHTML = origHTML;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
    }

    if (typeof window.astroidaRequestDuplicateConfirmation === 'function') {
      window.astroidaRequestDuplicateConfirmation({
        variantIds: [variantId],
        productId: productRoot ? productRoot.getAttribute('data-product-id') : '',
        productTitle: productTitleNode ? productTitleNode.textContent.trim() : '',
        submitter: btn,
        onConfirm: performIconAdd,
        onCancel: function() {
          btn.innerHTML = origHTML;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      });
    } else {
      performIconAdd();
    }

    return false;
  };
}
